import {createSelector} from "reselect";

export const modalStoreSelect = (state) => state.modal;

export const modalSelector = createSelector(
  modalStoreSelect,
  (state) => state
);